import React from 'react';
import "./c92_profile_boxes_with_links.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { isMobileOnly } from "react-device-detect";

const boxesClassname = (param) => {
    let className = "btn menubutton";

    if (param.selected) {
        className = "btn menubutton-selected"
    }

    if (param.new_tab) {
        className += " new-tab "
    }

    if (param.submenu) {
        className += " submenu "
    }

    return className
};

const ProfileBoxesWithLinks = (props) => {

    return <div id="profileboxes">
        {!isMobileOnly ? <div className="btn-group-vertical button-section">
            {props.data.links ? props.data.links.map((object, index) =>
                <a key={index} target={object.new_tab ? '_blank' : null} className={boxesClassname(object)} href={object.url}>{object.label}</a>
            ) : null}
        </div> : <div className="scrolling-wrapper">
            {props.data.links ? props.data.links.map((object, index) =>
                <a key={index} target={object.new_tab ? '_blank' : null} className={boxesClassname(object)} href={object.url}>{object.label}</a>
            ) : null}
            <div className="ending-space" />
        </div>}
    </div>;
};

class C92ProfileBoxes extends TemplateComponent {
    componentRender(data) {
        return (
            <ProfileBoxesWithLinks data={data} />
        );
    };
};

export default C92ProfileBoxes;
